import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Label, Radio, RadioWrapper } from './styles.js';

const RadioButton = ({
  label,
  name,
  isChecked = false,
  value,
  onChange = () => {},
  isSmall,
  isDisabled = false,
  isErrored = false,
  children,
  ...props
}) => (
  <Wrapper className={isChecked && 'is-checked'} onClick={() => onChange({ target: { value } })} {...props}>
    <RadioWrapper>
      <Radio
        tabIndex={-1}
        type="radio"
        id={`${name}-${label}`}
        name={name}
        value={value}
        checked={isChecked}
        isSmall={isSmall}
        isDisabled={isDisabled}
        disabled={isDisabled}
        isErrored={isErrored}
        onChange={onChange}
      />
      <Label htmlFor={`${name}-${label}`} isSmall={isSmall}>
        {label}
      </Label>
    </RadioWrapper>
    {children ? children : null}
  </Wrapper>
);

RadioButton.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  isSmall: PropTypes.bool,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  isErrored: PropTypes.bool,
  children: PropTypes.node
};

export default RadioButton;
